export default __webpack_public_path__ + "static/icon-tile-size-light-ec86c0ebb3437aa7272ee57760915b08f5fab49fb290f65411ccb175f5fe9d88.png";